import React from 'react';
import PropTypes from 'prop-types';

import {
  Field,
} from 'redux-form';

import renderToggleButtonField from '../../../shared/components/form/ToggleButton';

const AssistValues = [
  {
    value: null, label: '​➖', description: '-', color: 'secondary',
  },
  {
    value: true, label: '✔️', description: 'Presente', color: 'success',
  },
  {
    value: false, label: '​❌', description: 'Ausente', color: 'danger',
  },
];

const StudentAssistancesTable = ({
  fields = {},
  meta: { error, submitFailed },
  onChangeChecked,
  onSort,
  items,
  present,
  editScore,
  sortColumn,
  sortType,
}) => {
  const checkBoxLabelStyle = {
    marginTop: '0px',
    display: 'flex',
    justifyContent: 'center',
  };

  const thStyle = {
    padding: '0.07rem',
  };

  if (!thStyle) {
    return null;
  }

  return (
    <>
      <table className="table table-striped check-in">
        <thead>
          <tr>
            <th style={thStyle} scope="col col-2">N&uacute;mero de documento</th>
            <th
              style={thStyle}
              onClick={() => onSort({ sortColumn: 'name', sortType })}
              scope="col col-3"
            >
              Nombre{' '}
              <i
                className={
                  `fa fa-sort-alpha-${sortColumn === 'name' && sortType === 'desc' ? sortType : 'asc'}`
                }
                aria-hidden="true"
              />
            </th>
            <th
              style={thStyle}
              onClick={() => onSort({ sortColumn: 'surname', sortType })}
              scope="col col-3"
            >
              Apellido{' '}
              <i
                className={`fa fa-sort-alpha-${sortColumn === 'surname' && sortType === 'desc' ? sortType : 'asc'}`}
                aria-hidden="true"
              />
            </th>
            <th style={thStyle} scope="col col-2">Presente</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((student, index) => {
            const [assistanceValue = {}] = AssistValues.filter(a => items[index] && a.value === items[index].present);
            return (
              <tr key={`${student}`} id={`${student}`} className={items[index] && items[index].deleted ? 'hidden' : ''}>
                <td style={thStyle} className="col col-2">
                  <span>{items[index] && items[index].doc}</span>
                </td>
                <td style={thStyle} className="col col-3">
                  <span>{items[index] && items[index].name}</span>
                </td>
                <td style={thStyle} className="col col-3">
                  <span>{items[index] && items[index].surname}</span>
                </td>

                <td style={thStyle} className="col col-2">
                  <div className="form" style={{ display: 'flex' }}>
                    <div
                      className="form__form-group-input-wrap form__form-group-input-wrap--error "
                      style={{ width: 'auto' }}
                    >
                      {
                        !editScore
                          ? (<span role="img" aria-label={assistanceValue.description}>​{assistanceValue.label}</span>)
                          : (
                            <Field
                              labelStyle={checkBoxLabelStyle}
                              name={`${student}.present`}
                              component={renderToggleButtonField}
                              value={present}
                              onChange={(checked) => {
                                onChangeChecked({
                                  name: fields.name,
                                  target: { name: `${student}.present`, checked },
                                  doc: items[index] && items[index].doc,
                                });
                              }
                              }
                              readOnly={!editScore}
                              disabled={editScore}
                            />
                          )
                      }
                    </div>
                  </div>
                </td>

              </tr>
            );
          })}
        </tbody>
      </table>
      {
        submitFailed && error && (
          <span className="form__form-group-error" style={{ marginBottom: '0.5rem' }}>
            {error}
          </span>
        )
      }
    </>
  );
};

StudentAssistancesTable.propTypes = {
  onChangeChecked: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
  fields: PropTypes.shape({}).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  meta: PropTypes.shape({}),
  present: PropTypes.bool,
  sortColumn: PropTypes.string,
  sortType: PropTypes.string,
  editScore: PropTypes.bool.isRequired,
};

StudentAssistancesTable.defaultProps = {
  meta: {},
  present: null,
  sortColumn: 'name',
  sortType: 'asc',
};

export default StudentAssistancesTable;
